var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"added"}},[_c('div',{staticClass:"wrap-msg"},[_c('img',{staticClass:"cross-exit",attrs:{"src":require("../assets/img/cancel.svg")},on:{"click":function($event){_vm.$emit('closeAdded')}}}),_vm._v(" "),_c('p',[_vm._v("Товар добавлен в вашу корзину")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-640374ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Added.vue
// module id = 114
// module chunks = 0